import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customerBookingDetails } from "../../Redux/Actions";
import BookingDetails from "./Bookingdetails";
function Dashboard() {
  const otpverification = useSelector((state) => state.otpverification);
  const { loading, otpVerificationResponse, error } = otpverification;

  const customerBookingDetailsResponse = useSelector(
    (state) => state.customerBookingDetails
  );

  const dispatch = useDispatch();
  try {
    if (JSON.parse(localStorage.getItem("user"))) {
      const userFromLocal = JSON.parse(localStorage.getItem("user"));
      var token = userFromLocal.token;
    }
  } catch (error) {}

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));

    dispatch(customerBookingDetails(userFromLocal.token));
  }, []);

  useEffect(() => {
    if (
      customerBookingDetailsResponse &&
      customerBookingDetailsResponse.customerDetailResponse &&
      customerBookingDetailsResponse.customerDetailResponse.results
    ) {
      var details =
        customerBookingDetailsResponse.customerDetailResponse.results;
      console.log(details);
    }
  }, [customerBookingDetailsResponse]);

  return (
    <div>
      <h1>Welcome to redcliffe Dashboard</h1>
      {customerBookingDetailsResponse &&
        customerBookingDetailsResponse.customerDetailResponse &&
        customerBookingDetailsResponse.customerDetailResponse.results &&
        customerBookingDetailsResponse.customerDetailResponse.results.map(
          (element) => {
            return <BookingDetails token={token} booking={element} />;
          }
        )}
    </div>
  );
}

export default {
  component: Dashboard,
};
